import draft from './draft.svg';
import portOperations from './portOperations.svg';
import safetyAndSecurity from './safetyAndSecurity.svg';

export default {
  draft,
  portOperations,
  safetyAndSecurity,
};
